"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CausalityContainer = void 0;
var risks_1 = require("../../interfaces/risks");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var utils_1 = require("../../utils");
var App_1 = require("../../App");
var api_1 = require("../../api");
var buttons_1 = require("../buttons");
var generic_1 = require("../generic");
var lists_1 = require("../lib/lists");
var iterUtils_1 = require("../lib/iterUtils");
var causalityDisplay_1 = require("../causalities/causalityDisplay");
var CausalityContainer = (function (_super) {
    __extends(CausalityContainer, _super);
    function CausalityContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            show_completed: false,
        };
        return _this;
    }
    CausalityContainer.prototype.getCheckboxId = function () {
        return this.props.isCause ? "show_completed_causes" : "show_completed_effects";
    };
    CausalityContainer.prototype.toggleDoneDiscarded = function (event) {
        this.setState(function (prevState) {
            return {
                show_completed: !prevState.show_completed
            };
        });
    };
    CausalityContainer.prototype.getStatuses = function () {
        return this.state.show_completed ?
            risks_1.CausalityStatusChoices.INCOMPLETE.concat(risks_1.CausalityStatusChoices.COMPLETE) :
            risks_1.CausalityStatusChoices.INCOMPLETE;
    };
    CausalityContainer.prototype.handleCreateNew = function (e) {
        (0, utils_1.preventDefault)(e);
        if (is_new_risk()) {
            notify_to_save_risk();
            return;
        }
        this.props.openDialog(null, this.props.isCause);
    };
    CausalityContainer.prototype.handleDetach = function (c) {
        return App_1.store.riskPage.accordion.checkDetachCausality(c).then(function (page) { return App_1.store.riskPage.accordion.removeCausality(c); }, function (error) {
            var reason = JSON.parse(error.responseText);
            if (reason.confirm) {
                optionDialog(reason.confirm, [{
                        text: gettext("Retain confidentiality"),
                        "class": "btn btn-primary",
                        click: function () { return App_1.store.riskPage.accordion.removeCausality(c, true); }
                    }, {
                        text: gettext("Make public"),
                        "class": "btn btn-secondary",
                        click: function () { return App_1.store.riskPage.accordion.removeCausality(c, false); }
                    }], null, null, 500);
            }
            else {
                api_1.api.apiErrorHandler(error, null, null);
            }
        });
    };
    CausalityContainer.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var causalities = props.causalities.sort(function (a, b) { return a.number - b.number; });
        return (React.createElement("div", { className: "CausalityContainer" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col custom-control custom-switch mt-2" },
                    React.createElement("input", { type: "checkbox", className: "custom-control-input", onClick: this.toggleDoneDiscarded.bind(this), checked: this.state.show_completed, id: this.getCheckboxId.bind(this)() }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: this.getCheckboxId.bind(this)() }, gettext("Show closed/discarded"))),
                React.createElement("div", { className: "col ml-auto m-2 text-right" },
                    React.createElement(buttons_1.ActionButton, { noMargin: true, className: "btn-sm", onClick: this.handleCreateNew.bind(this) },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                        " ",
                        props.isCause ? get_term("Add Cause") : get_term("Add Effect")))),
            React.createElement("div", { className: "Causality", id: props.isCause ? "causes_list" : "effects_list" },
                React.createElement(lists_1.ListObjects, { objects: causalities.filter(function (c) { return (0, iterUtils_1.contains)(_this.getStatuses(), c.status); }), editable: true, deletable: false, detachable: true, handleEdit: function (c) {
                        _this.props.openDialog(c);
                    }, handleDetach: this.handleDetach.bind(this), getKey: function (c) { return c.id; }, sortObjects: function (a, b) {
                        return a.status - b.status || a.number - b.number;
                    }, getListItemContent: function (c) { return React.createElement(causalityDisplay_1.CausalityDisplay, { causality: c }); }, groupByFunc: this.state.show_completed ?
                        function (c) { return c.status_display; } : null }))));
    };
    CausalityContainer = __decorate([
        mobx_react_1.observer
    ], CausalityContainer);
    return CausalityContainer;
}(React.Component));
exports.CausalityContainer = CausalityContainer;
